import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

interface UserDetailsModalProps {
  selectedUserUsername: string;
  selectedUserEmail: string;
  selectedUserGroups: string;
  modalIsOpen: boolean;
  toggleModal: () => void;
}

export const UserDetailsModal = (props: UserDetailsModalProps) => {
  return (
    <Modal isOpen={props.modalIsOpen} toggle={props.toggleModal}>
      <ModalHeader toggle={props.toggleModal}>User Details</ModalHeader>
      <div>
        <ModalBody>
          <div>Details for user {props.selectedUserUsername}</div>
          <hr></hr>
          <div>Email Address</div>
          <div>{props.selectedUserEmail}</div>
          <div>Groups</div>
          <div>{props.selectedUserGroups}</div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={() => props.toggleModal()}>
            Close
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};
